import axiosInstance from "services/axiosMiddleware";

export async function updateRelaxation(relaxation) {
  try {
    const { id, ...payload } = relaxation;

    if (!id) {
      throw new Error("Relaxation id is required");
    }

    const response = await axiosInstance.put(
      `/relaxation/relaxation/update/${id}`,
      payload
    );

    return response.data;

  } catch (error) {
    console.error(
      "Update relaxation API error:",
      error?.response?.data || error
    );

    throw error?.response?.data || error;
  }
}
